import { createIntlProvider } from '@piaas/piaas-ui-toolkit/i18n';
import { createElement, type PropsWithChildren, type ReactElement } from 'react';
import { useSelector } from 'react-redux';

import de from './translations/de';
import en from './translations/en';

const LocaleIntlProvider = createIntlProvider({ translations: { en, de } });

interface RootState {
  user: {
    locale?: string;
  };
}

const ConnectedIntlProvider = ({ children }: PropsWithChildren): ReactElement => {
  const locale = useSelector((state: RootState) => state.user.locale ?? 'en');

  return createElement(LocaleIntlProvider, { locale }, children);
};

export default ConnectedIntlProvider;
